import React from 'react';

import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ProfileHeader from './ProfileHeader';
import CategoriesHeader from './CategoriesHeader';
import ChipsHeader from './ChipsHeader';
import WeekHeader from './WeekHeader';

const HeadingContainer = (props) => {
  const location = useLocation();
  const [isViewHidden, setViewHidden] = useState(true);
  const { clientId } = props;
  useEffect(() => {
    if (location.pathname === '/home' || location.pathname === '/home/clientlist' || location.pathname.includes('home/editprofile') || location.pathname.includes('home/userprofile')) {
      setViewHidden(true);
    } else {
      setViewHidden(false);
    }
  }, [location]);
  return (
    !isViewHidden && clientId &&  (
      <div className="dashboard-top-side">
        <ProfileHeader clientId={clientId} />
        <CategoriesHeader clientId={clientId} />
        <ChipsHeader clientId={clientId} />
        <WeekHeader pageType="dashboard" clientId={clientId} />
      </div>
    )
  );
};
export default HeadingContainer;
